import "./loading.css";

export const LoadingAnimation = () => {
  return (
    <div className="w-full max-h-screen flex flex-col items-center justify-center">
      <h1 className="text-5xl text-muted-foreground py-5 font-semibold">Betöltés</h1>
      <div className="dot-wave text-muted-foreground my-5">
        <div className="dot-wave__dot text-muted-foreground "></div>
        <div className="dot-wave__dot text-muted-foreground "></div>
        <div className="dot-wave__dot text-muted-foreground "></div>
        <div className="dot-wave__dot text-muted-foreground "></div>
      </div>
    </div>
  )
}
